import React, { useEffect, useState } from "react";
import { useGL } from "./gl/use-gl";
import { useCanvasSize } from "./dimension/use-canvas-size";
import { useProgram } from "./gl/program/use-program";
export default function GLCanvas(props) {
    const { pixelRatio = 2, onRefresh, showDebugInfo, controller, initialProgram, webglAttributes } = props !== null && props !== void 0 ? props : {};
    const canvasRef = React.useRef(null);
    const gl = useGL({ canvasRef, webglAttributes });
    const { usedProgram } = useProgram({ gl, initialProgram, programs: props === null || props === void 0 ? void 0 : props.programs, showDebugInfo, controller });
    const { width, height } = useCanvasSize({ gl, canvasRef, pixelRatio });
    const [refresh, setRefresh] = useState(() => onRefresh);
    useEffect(() => {
        if (gl && usedProgram && refresh) {
            const cleanup = refresh(gl);
            return () => {
                cleanup === null || cleanup === void 0 ? void 0 : cleanup();
            };
        }
    }, [gl, usedProgram, refresh, width, height]);
    useEffect(() => {
        if (controller) {
            controller.setRefresh = (refreshMethod) => setRefresh(() => refreshMethod);
        }
    }, [controller, setRefresh]);
    return React.createElement("canvas", { ref: canvasRef, width: width, height: height, style: Object.assign(Object.assign({}, props === null || props === void 0 ? void 0 : props.style), { width: "100%", height: "100%" }) });
}
